import * as SMH from '../../../typings';

export default (http: SMH.HTTP, baseURL?: string): any => ({
  // 短信验证码登录
  login: async (params: SMH.LoginParams): SMH.RequestResponse<SMH.LoginData> => {
    const { countryCode, phoneNumber, code, deviceId, domain, captchaTicket, captchaRandstr, inviteCode, pf } = params;
    if (!countryCode || !phoneNumber || !code) {
      logger.smh.error('[SMH Warning]: No countryCode or phoneNumber or code.');
    }
    const res = await http({
      customAttributes: { apiName: 'loginWithSMS' },
      method: 'post',
      url: `${baseURL}/user/v1/sign-in/verify-sms-code/${countryCode}/${phoneNumber}/${code}`,
      params: {
        flag: params.flag || '', // TODO 为了兼容老版本，flag=1时才校验图形验证码，为''私有化不进行图形验证检验
        device_id: deviceId,
        domain,
        ...(captchaTicket && { captcha_ticket: captchaTicket }),
        ...(captchaRandstr && { captcha_randstr: captchaRandstr }),
        ...(inviteCode && { invite_code: inviteCode }),
        ...(pf && { pf }),
      },
    });
    return res;
  },
  // 发送短信验证
  sendSMS: async (params: SMH.SendSMSData): SMH.RequestResponse<void> => {
    const { countryCode, phoneNumber, domain, type, captchaTicket, captchaRandstr, inviteCode, pf } = params;
    if (!countryCode || !phoneNumber) {
      logger.smh.error('[SMH Warning]: No countryCode or phoneNumber.');
    }
    const res = await http({
      customAttributes: { apiName: 'sendSMS' },
      method: 'post',
      url: `${baseURL}/user/v1/sign-in/send-sms-code/${countryCode}/${phoneNumber}`,
      params: {
        flag: params.flag || '', // TODO 为了兼容老版本，flag=1时才校验图形验证码，为''私有化不进行图形校验
        domain,
        ...(type && { type }),
        ...(captchaTicket && { captcha_ticket: captchaTicket }),
        ...(captchaRandstr && { captcha_randstr: captchaRandstr }),
        ...(inviteCode && { invite_code: inviteCode }),
        ...(pf && { pf }),
      },
    });
    return res;
  },
  // 注册免费版直接登录
  register: async (params: SMH.RegisterParams): SMH.RequestResponse<SMH.RegisterData> => {
    const {
      countryCode,
      phoneNumber,
      code,
      deviceId,
      domain,
      captchaTicket,
      captchaRandstr,
      orgName,
      business,
      role,
      scale,
      wechatCode,
    } = params;
    if (!countryCode || !phoneNumber || !code) {
      logger.smh.error('[SMH Warning]: No countryCode or phoneNumber or code.');
    }
    const res = await http({
      customAttributes: { apiName: 'RegisterWithPhone' },
      method: 'post',
      url: `${baseURL}/user/v1/sign-in/register-official-free/${countryCode}/${phoneNumber}/${code}`,
      params: {
        device_id: deviceId,
        domain,
        ...(captchaTicket && { captcha_ticket: captchaTicket }),
        ...(captchaRandstr && { captcha_randstr: captchaRandstr }),
        ...(wechatCode && { wechatCode }),
      },
      data: {
        orgName,
        business,
        role,
        scale,
      },
    });
    return res;
  },
  // 登出
  logout: (userToken: SMH.UserToken): void => {
    http({
      customAttributes: { apiName: 'logout' },
      method: 'post',
      url: `${baseURL}/user/v1/sign-out`,
      params: { user_token: userToken },
    });
  },
  // 游客登出
  vistorLogout: (vistorAccessToken: string): void => {
    // 游客登出
    http({
      method: 'post',
      url: `${baseURL}/user/v1/collect/sign-out/?access_token=${vistorAccessToken}`,
    });
  },
  // 获取 sso 登出 url
  getSSOLogoutUrl: (params: { corpId?: string; domain?: string; ssoWay?: string; userToken: SMH.UserToken }) => {
    const { corpId, domain, ssoWay, userToken } = params;
    return http({
      customAttributes: { apiName: 'getSSOLogoutUrl' },
      method: 'get',
      url: `${baseURL}/user/v1/sign-out/sso-logout-redirect/${corpId}`,
      params: { domain, sso_way: ssoWay, user_token: userToken },
    });
  },
  // 获取登录二维码：app扫码登录
  getQRCode: async (
    deviceId: string,
    domain: string,
    httpsAgent?: any,
    httpAgent?: any,
  ): SMH.RequestResponse<SMH.GetQRCodeData> => {
    const res = await http({
      customAttributes: { apiName: 'getQRCode' },
      method: 'get',
      url: `${baseURL}/user/v1/qr-code`,
      params: { device_id: deviceId, domain },
      httpsAgent,
      httpAgent,
    });
    return res;
  },
  // 查询登录二维码状态
  getQRCodeStatus: async (uuid: string): SMH.RequestResponse<SMH.GetQRCodeStatusData> => {
    const res = await http({
      customAttributes: { apiName: 'getQRCodeStatus' },
      method: 'get',
      url: `${baseURL}/user/v1/qr-code/${uuid}`,
    });
    return res;
  },
  // 通过二维码获取登录信息
  getLoginInfo: async (uuid: string): SMH.RequestResponse<SMH.GetQRCodeLoginData> => {
    const res = await http({
      customAttributes: { apiName: 'getLoginInfo' },
      method: 'get',
      url: `${baseURL}/user/v1/qr-code/${uuid}/user-token`,
    });
    return res;
  },
  // 获取企微配置
  getWeComConfig: async (domain: string) => {
    const res = await http({
      customAttributes: { apiName: 'getWeComConfig' },
      method: 'get',
      url: `${baseURL}/user/v1/organization/login-settings`,
      params: { domain },
    });
    return res;
  },
  // 通过企微code登录
  loginByWeCom: async ({
    code = '',
    corpid = '',
    deviceId = '',
    domain = '',
    smsCode = '',
    phoneNumber = '',
    countryCode = '+86',
    inviteCode = '',
    pf = '',
  }) => {
    let result: CoFile.LoginSMSData = {
      organizations: [],
      userId: -1,
      userToken: '',
      userTokenExpiresIn: 0,
      userTokenStart: 0,
      isNewUser: 'unknown',
    };
    try {
      const res = await http({
        customAttributes: { apiName: 'loginByWeCom' },
        method: 'post',
        url: `${baseURL}/user/v1/sign-in/verify-wework-code/${code}`,
        params: {
          corpid,
          domain,
          device_id: deviceId,
          cross_org: 0,
          ...(phoneNumber && { phone_number: phoneNumber }),
          ...(countryCode && { country_code: countryCode }),
          ...(smsCode && { sms_code: smsCode }),
          ...(inviteCode && { invite_code: inviteCode }),
          ...(pf && { pf }),
        },
      });
      const { data } = res;
      const { userId, userToken, expiresIn, organizations, isNewUser } = data;
      result = {
        organizations,
        userId,
        userToken,
        userTokenExpiresIn: expiresIn,
        userTokenStart: new Date().getTime() / 1000,
        // eslint-disable-next-line no-nested-ternary
        isNewUser: isNewUser === undefined ? 'unknown' : isNewUser ? 'yes' : 'no',
      };
    } catch (e: any) {
      result = {
        ...e,
        hasError: true,
      };
    }
    return result;
  },
  // 通过腾讯会议code登录
  loginByMeeting: async ({
    code,
    deviceId,
    countryCode,
    phoneNumber,
    smsCode,
    inviteCode,
    meetingToken,
  }: {
    code: string;
    deviceId: string;
    countryCode?: string;
    phoneNumber?: string;
    smsCode?: string;
    inviteCode?: string;
    meetingToken?: string;
  }) => {
    let result: CoFile.LoginSMSData = {
      organizations: [],
      userId: -1,
      userToken: '',
      userTokenExpiresIn: 0,
      userTokenStart: 0,
      isNewUser: 'unknown',
      hasAppliedChannelOrg: true,
    };
    try {
      const res = await http({
        customAttributes: { apiName: 'loginByMeeting' },
        method: 'post',
        url: `${baseURL}/user/v1/sign-in/verify-meeting-code/${code}`,
        params: {
          device_id: deviceId,
          phone_number: phoneNumber,
          country_code: countryCode,
          sms_code: smsCode,
          ...(inviteCode && { invite_code: inviteCode }),
          ...(meetingToken && { meeting_token: meetingToken }),
        },
      });
      const { data } = res;
      const { userId, userToken, expiresIn, organizations, isNewUser, hasAppliedChannelOrg } = data;
      result = {
        organizations,
        userId,
        hasAppliedChannelOrg,
        userToken,
        userTokenExpiresIn: expiresIn,
        userTokenStart: new Date().getTime() / 1000,
        // eslint-disable-next-line no-nested-ternary
        isNewUser: isNewUser === undefined ? 'unknown' : isNewUser ? 'yes' : 'no',
      };
    } catch (e: any) {
      result = {
        ...e,
        hasError: true,
      };
    }
    return result;
  },
  // 通过微信code登录
  loginByWeChat: async ({
    code = '',
    deviceId = '',
    smsCode = '',
    phoneNumber = '',
    countryCode = '+86',
    domain = '',
    inviteCode = '',
    pf = '',
  }) => {
    let result: CoFile.LoginSMSData = {
      organizations: [],
      userId: -1,
      userToken: '',
      userTokenExpiresIn: 0,
      userTokenStart: 0,
      isNewUser: 'unknown',
      hasAppliedChannelOrg: true,
    };
    try {
      const res = await http({
        customAttributes: { apiName: 'loginByWeChat' },
        method: 'post',
        url: `${baseURL}/user/v1/sign-in/verify-wechat-code/${code}`,
        params: {
          device_id: deviceId,
          domain,
          ...(phoneNumber && { phone_number: phoneNumber }),
          ...(countryCode && { country_code: countryCode }),
          ...(smsCode && { sms_code: smsCode }),
          ...(inviteCode && { invite_code: inviteCode }),
          ...(pf && { pf }),
        },
      });
      const { data } = res;
      const { userId, userToken, expiresIn, organizations, isNewUser, hasAppliedChannelOrg } = data;
      result = {
        organizations,
        userId,
        userToken,
        userTokenExpiresIn: expiresIn,
        userTokenStart: new Date().getTime() / 1000,
        // eslint-disable-next-line no-nested-ternary
        isNewUser: isNewUser === undefined ? 'unknown' : isNewUser ? 'yes' : 'no',
        hasAppliedChannelOrg,
      };
    } catch (e: any) {
      result = {
        ...e,
        hasError: true,
      };
    }
    return result;
  },
  // 获取yufu sso配置
  getYufuUrl: async ({
    tenantKey,
    from,
    type,
    custom_state,
  }: {
    tenantKey: string;
    from: string;
    type: string;
    custom_state: string;
  }) => {
    const res = await http({
      customAttributes: { apiName: 'getYufuUrl' },
      method: 'get',
      url: `${baseURL}/user/v1/sign-in/yufu-endpoint/${tenantKey}`,
      params: { auto_redirect: false, type, from, custom_state },
    });
    return res;
  },
  // 通过yufu sso登录
  loginByYufu: async ({
    tenantKey = '',
    code = '',
    type = '',
    deviceId = '',
    smsCode = '',
    phoneNumber = '',
    countryCode = '+86',
    domain = '',
    inviteCode = '',
    pf = '',
  }) => {
    let result: CoFile.LoginSMSData = {
      organizations: [],
      userId: -1,
      userToken: '',
      userTokenExpiresIn: 0,
      userTokenStart: 0,
      isNewUser: 'unknown',
    };
    try {
      const res = await http({
        customAttributes: { apiName: 'loginByYufu' },
        method: 'post',
        url: `${baseURL}/user/v1/sign-in/verify-yufu-code/${tenantKey}/${code}`,
        params: {
          type,
          device_id: deviceId,
          domain,
          ...(phoneNumber && { phone_number: phoneNumber }),
          ...(countryCode && { country_code: countryCode }),
          ...(smsCode && { sms_code: smsCode }),
          ...(inviteCode && { invite_code: inviteCode }),
          ...(pf && { pf }),
        },
      });
      const { data } = res;
      const { userId, userToken, expiresIn, organizations, isNewUser } = data;
      result = {
        organizations,
        userId,
        userToken,
        userTokenExpiresIn: expiresIn,
        userTokenStart: new Date().getTime() / 1000,
        // eslint-disable-next-line no-nested-ternary
        isNewUser: isNewUser === undefined ? 'unknown' : isNewUser ? 'yes' : 'no',
      };
    } catch (e: any) {
      result = {
        ...e,
        hasError: true,
      };
    }
    return result;
  },
  // 获取sso配置
  getSSOurl: async ({
    orgDomain,
    domain,
    from,
    custom_state,
  }: {
    orgDomain?: string;
    domain?: string;
    from?: string;
    custom_state?: string;
  }) => {
    const res = await http({
      customAttributes: { apiName: 'getSSOurl' },
      method: 'get',
      url: `${baseURL}/user/v1/sign-in/sso-login-redirect${orgDomain ? `/${orgDomain}` : ''}`,
      params: {
        auto_redirect: false,
        ...(from && { from }),
        ...(custom_state && { custom_state }),
        ...(domain && { domain }),
      },
    });
    return res;
  },
  // 统一身份校验
  verifyAccountLogin: async ({
    type = '',
    credential = '',
    orgDomain = '',
    smsCode = '',
    phoneNumber = '',
    countryCode = '',
    domain = '',
    deviceId = '',
    inviteCode = '',
    pf = '',
    ldapType = '',
    accountName = '',
    accountPassword = '',
  }) => {
    let result: CoFile.LoginSMSData = {
      organizations: [],
      userId: -1,
      userToken: '',
      userTokenExpiresIn: 0,
      userTokenStart: 0,
      isNewUser: 'unknown',
    };
    try {
      const res = await http({
        customAttributes: { apiName: 'loginBySSO' },
        method: 'post',
        url: `${baseURL}/user/v1/sign-in/verify-account-login/${orgDomain}`,
        params: {
          device_id: deviceId,
          type,
          ...(domain && { domain }),
          ...(credential && { credential }),
          ...(ldapType && { ldap_type: ldapType }),
          ...(phoneNumber && { phone_number: phoneNumber }),
          ...(countryCode && { country_code: countryCode }),
          ...(smsCode && { sms_code: smsCode }),
          ...(inviteCode && { invite_code: inviteCode }),
          ...(pf && { pf }),
        },
        data: {
          ...(accountName && { accountName }),
          ...(accountPassword && { accountPassword }),
        },
      });
      const { data } = res;
      const { userId, userToken, expiresIn, organizations, isNewUser } = data;
      result = {
        organizations,
        userId,
        userToken,
        userTokenExpiresIn: expiresIn,
        userTokenStart: new Date().getTime() / 1000,
        // eslint-disable-next-line no-nested-ternary
        isNewUser: isNewUser === undefined ? 'unknown' : isNewUser ? 'yes' : 'no',
      };
    } catch (e: any) {
      result = {
        ...e,
        hasError: true,
      };
    }
    return result;
  },
  // 获取ad配置
  getLdapLoginConfig: async ({ orgDomain, domain }: { orgDomain?: string; domain?: string }) => {
    const res = await http({
      customAttributes: { apiName: 'getLdapLoginConfig' },
      method: 'get',
      url: `${baseURL}/user/v1/sign-in/ldap-login-config${orgDomain ? `/${orgDomain}` : ''}`,
      params: {
        ...(domain && { domain }),
      },
    });
    return res;
  },
  // 账密登录
  async loginByPassword({ corpId = '', deviceId = '', domain = '', accountName = '', password = '', pf = '' }) {
    let result: CoFile.LoginSMSData = {
      organizations: [],
      userId: -1,
      userToken: '',
      userTokenExpiresIn: 0,
      userTokenStart: 0,
      isNewUser: 'unknown',
    };
    try {
      const res = await http({
        customAttributes: { apiName: 'loginByPassword' },
        method: 'post',
        url: `${baseURL}/user/v1/sign-in/verify-account-password`,
        params: {
          ...(corpId && { corp_id: corpId }),
          ...(deviceId && { device_id: deviceId }),
          ...(domain && { domain }),
        },
        data: {
          accountName,
          accountPassword: password,
        },
      });
      const { data } = res;
      const { userId, userToken, expiresIn, organizations, isNewUser } = data;
      result = {
        organizations,
        userId,
        userToken,
        userTokenExpiresIn: expiresIn,
        userTokenStart: new Date().getTime() / 1000,
        // eslint-disable-next-line no-nested-ternary
        isNewUser: isNewUser === undefined ? 'unknown' : isNewUser ? 'yes' : 'no',
      };
    } catch (e: any) {
      result = {
        ...e,
        hasError: true,
      };
    }
    return result;
  },
  // 私有化下获取机构列表
  getCorpList: async () => {
    const res = await http({
      customAttributes: { apiName: 'getCorpList' },
      method: 'get',
      url: `${baseURL}/user/v1/organization/login-org-list`,
    });
    return res;
  },
  // 获取自定义企业网页信息
  getOrgCustomPortal: async (domain: string) => {
    const res = await http({
      customAttributes: { apiName: 'getOrgCustomPortal' },
      method: 'get',
      url: `${baseURL}/user/v1/custom-portal/${domain}`,
    });
    return res;
  },
  // 测试私有化服务端域名是否通
  testInternalServer: (url: string) =>
    http({
      customAttributes: { apiName: 'testInternalServer' },
      method: 'get',
      url: `${url}/api/v1/version`,
    }),
  getRemoteConfig: () =>
    http({
      customAttributes: { apiName: 'getRemoteConfig' },
      method: 'get',
      url: `${baseURL}/api/v1/config`,
    }),
  getAnnouncements: ({ type = 'systemMaintenance' }) =>
    http({
      customAttributes: { apiName: 'getAnnouncements' },
      method: 'get',
      url: `${baseURL}/api/v1/announcements`,
      params: { type },
    }),
});
